<div class="dialog-container">
  <h2>Confirm Delete</h2>
  <p>{{ data.message }}</p>
  <div class="dialog-actions">
    <button (click)="cancel()">No</button>
    <button (click)="confirm()">Yes</button>
  </div>
</div>
